
















import Vue from 'vue';
import RadioGroup from '@/Shared/RadioGroup.vue';

export default Vue.extend({
  name: 'RadioToggle',
  components: { RadioGroup },
  props: {
      value: {
          required: true
      },
      defaultValue: {
        required: false,
        type: Boolean
      }
  },
  model: {
    prop: 'value',
    event: 'change'
  },
  mounted() {
    if (typeof this.defaultValue === 'boolean' && typeof this.toggleValue !== 'boolean') {
      this.toggleValue = this.defaultValue;
      this.$emit('change', this.toggleValue);
    }
  },
  data() {
      return {
          toggleValue: this.value
      };
  },
  watch: {
      value(newValue) {
          this.toggleValue = newValue;
      }
  },
  methods: {
      toggleChanged($event: boolean) {
          this.$emit('change', $event);
      }
  }
});
